var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("alert-modal", {
        ref: "confirm",
        attrs: { cancelable: "", alertText: _vm.alertText },
        on: {
          confirm: _vm.confirmConfirmation,
          cancel: _vm.cancelConfirmation,
        },
      }),
      _vm.showButtonVisible
        ? _c(
            "b-button",
            {
              attrs: { size: "sm", variant: "outline-secondary" },
              on: { click: _vm.show },
            },
            [_vm._v(_vm._s(_vm.config.showButtonHtml))]
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "basePictureModal",
          staticClass: "text-sm-left",
          attrs: { id: "basePictureModal", centered: "", "hide-footer": "" },
          on: { hidden: _vm.onHidden, shown: _vm.onShown },
        },
        [
          _c(
            "template",
            { slot: "modal-header" },
            [
              _vm.config.showPicture
                ? _c(
                    "div",
                    { staticClass: "modal-photo-container" },
                    [
                      _c("picture-placeholder", {
                        attrs: {
                          textIn: _vm.config.modalTitle,
                          pictureUrl: _vm.config.pictureUrl,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "modal-toolbar" }, [
                _c(
                  "span",
                  { staticClass: "modal-btn", on: { click: _vm.hide } },
                  [_c("i", { staticClass: "fi-x nav-icon" })]
                ),
              ]),
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.config.modalTitle)),
              ]),
              _c(
                "b-nav",
                {
                  staticClass: "modal-nav-bar",
                  class: {
                    "modal-nav-bar-no-picture": !!!_vm.config.showPicture,
                  },
                },
                _vm._l(_vm.tabs, function (tab, index) {
                  return _c(
                    "b-nav-item",
                    {
                      key: tab.title,
                      staticClass: "modal-nav-link",
                      class: { navLinkActive: tab.id == _vm.currentActiveTab },
                      on: {
                        click: function ($event) {
                          _vm.currentActiveTab = tab.id
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(tab.title.toUpperCase()))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          "error" == _vm.currentActiveTab
            ? _c("div", [
                _c("div", { staticClass: "tab-load-error" }, [
                  _vm._v("Error in Tab Load"),
                ]),
              ])
            : _c("div"),
        ],
        2
      ),
      _vm._t("button"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }